<template>
  <div>
    <h2 style="display: inline; margin-right: 10px;">Anexos</h2>
    <h5 style="display: inline;">Tam. máx. 5mb.</h5>

    <span v-if="camposFiltrados.length === 0">
      Os anexos obrigatórios já foram enviados ou não são necessários.
    </span>
    <div class="form-control" v-for="campo in camposFiltrados" :key="campo">
      <label :for="campo">{{ labels[campo] }}</label>
      <input type="file" multiple :id="campo" :name="campo" accept="image/*,application/pdf" :ref="campo"
        :required="(isAnexoRequired(campo) || !candidatoExiste)" />
      <p v-if="anexosCache[campo]?.resposta_sworks" class="error-message">
        Erro: {{ anexosCache[campo].resposta_sworks }}
      </p>
    </div>

    <div class="form-control" v-if=" dadosPessoais.estado_civil === 'uniao_estavel' && (isAnexoRequired('cf_anexo_certidao_nascimento_casamento') === true || candidatoExiste === false)">
      <label for="cf_anexo_uniao_estavel">Certidão de União Estável:</label>
      <input type="file" multiple id="cf_anexo_uniao_estavel" name="cf_anexo_uniao_estavel"
        accept="image/*,application/pdf" ref="cf_anexo_uniao_estavel" required />
      <p v-if="anexosCache['cf_anexo_uniao_estavel']?.resposta_sworks" class="error-message">
        Erro: {{ anexosCache["cf_anexo_uniao_estavel"].resposta_sworks }}
      </p>
    </div>

    <div class="form-control" v-if=" dadosPessoais.sexo === 'M' && dadosDocumentacao.estrangeiro !== 'sim' && (isAnexoRequired('cf_anexo_certificado_reservista') || !candidatoExiste)">
      <label for="cf_anexo_certificado_reservista">Certificado de Reservista:</label>
      <input type="file" multiple id="cf_anexo_certificado_reservista" name="cf_anexo_certificado_reservista"
        accept="image/*,application/pdf" ref="cf_anexo_certificado_reservista" required />
      <p v-if="anexosCache['cf_anexo_certificado_reservista']?.resposta_sworks" class="error-message">
        Erro:
        {{ anexosCache["cf_anexo_certificado_reservista"].resposta_sworks }}
      </p>
    </div>

    <div class="form-control" v-if=" dadosPessoais.pcd === 'sim' &&  (isAnexoRequired('cf_anexo_laudo_pcd') === true || candidatoExiste === false)">
      <label for="cf_anexo_laudo_pcd">Laudo PCD:</label>
      <input type="file" multiple id="cf_anexo_laudo_pcd" name="cf_anexo_laudo_pcd" accept="image/*,application/pdf"
        ref="cf_anexo_laudo_pcd" required />
      <p v-if="anexosCache['cf_anexo_laudo_pcd']?.resposta_sworks" class="error-message">
        Erro: {{ anexosCache["cf_anexo_laudo_pcd"].resposta_sworks }}
      </p>
    </div>

    <div class="form-control" v-if="  dadosPessoais.aposentado === 'sim' && (isAnexoRequired('cf_anexo_comprovante_aposentadoria') === true || candidatoExiste === false)">
      <label for="cf_anexo_comprovante_aposentadoria">Comprovante de Aposentadoria:</label>
      <input type="file" multiple id="cf_anexo_comprovante_aposentadoria" name="cf_anexo_comprovante_aposentadoria"
        accept="image/*,application/pdf" ref="cf_anexo_comprovante_aposentadoria" required />
      <p v-if="
        anexosCache['cf_anexo_comprovante_aposentadoria']?.resposta_sworks
      " class="error-message">
        Erro:
        {{ anexosCache["cf_anexo_comprovante_aposentadoria"].resposta_sworks }}
      </p>
    </div>

    <div class="form-control" v-if="((dadosDocumentacao.estrangeiro === 'sim' && dadosDocumentacao.naturalizado === 'sim') || dadosDocumentacao.estrangeiro !== 'sim') && (isAnexoRequired('cf_anexo_titulo_eleitor') === true || candidatoExiste === false)">
      <label for="cf_anexo_titulo_eleitor">Título de eleitor:</label>
      <input type="file" multiple id="cf_anexo_titulo_eleitor" name="cf_anexo_titulo_eleitor"
        accept="image/*,application/pdf" ref="cf_anexo_titulo_eleitor" required />
      <p v-if="anexosCache['cf_anexo_titulo_eleitor']?.resposta_sworks" class="error-message">
        Erro: {{ anexosCache["cf_anexo_titulo_eleitor"].resposta_sworks }}
      </p>
    </div>
    <div class="form-control" v-if="(isAnexoRequired('cf_anexo_pis_pasep') === true || candidatoExiste === false)">
      <label for="cf_anexo_pis_pasep">PIS/PASEP:</label>
      <input type="file" multiple id="cf_anexo_pis_pasep" name="cf_anexo_pis_pasep"
        accept="image/*,application/pdf" ref="cf_anexo_pis_pasep" />
      <p v-if="anexosCache['cf_anexo_pis_pasep']?.resposta_sworks" class="error-message">
        Erro: {{ anexosCache["cf_anexo_pis_pasep"].resposta_sworks }}
      </p>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  directives: { mask },
  props: {
    dadosPessoais: Object,
    dadosDocumentacao: Object,
    dadosBancarios: Object,
    anexosCandidato: Array,
    candidatoExiste: Boolean,
  },
  data() {
    return {
      anexosCache: {},
      campos: [
        "cf_anexo_foto_cracha",
        "cf_anexo_carteira_trabalho_digital",
        "cf_anexo_rg",
        "cf_anexo_cpf",
        "cf_anexo_comprovante_residencia",
        "cf_anexo_certidao_nascimento_casamento",
        "cf_anexo_comprovante_escolaridade",
        "cf_anexo_info_bancaria",
        "cf_anexo_comprovante_desligamento",
        "cf_anexo_carteira_vacinacao",
      ],
      camposOpcionais: [
        "cf_anexo_cnh",
        "cf_anexo_titulo_eleitor",
        "cf_anexo_certificado_reservista",
        "cf_anexo_laudo_pcd",
        "cf_anexo_comprovante_aposentadoria",
        "cf_anexo_uniao_estavel",
        "cf_laudo_deficiencia",
        "cf_anexo_pis_pasep",
      ],
    };
  },

  computed: {
    camposFiltrados() {
      return this.campos.filter((campo) => {
        const isShowCampo = this.isAnexoRequired(campo) || !this.candidatoExiste;

        if (campo === "cf_anexo_info_bancaria") {
          // inclui o campo quando dadosBancarios.banco === "sim" OU quando isShowCampo for true
          return (this.dadosBancarios?.banco === "sim") || isShowCampo;
        }

        return isShowCampo;
      });
    },

    labels() {
      let labelNomeRg = "";

      if (this.dadosDocumentacao.estrangeiro === "sim") {
        labelNomeRg = "RNE";
        if (this.dadosDocumentacao.naturalizado === "sim") {
          labelNomeRg = "RG/CPF";
        }
      } else {
        labelNomeRg = "RG/CPF";
      }

      let labelCertidao = "";
      switch (this.dadosPessoais.estado_civil) {
        case "solteiro":
          labelCertidao = "Certidão de Nascimento:";
          break;
        case "casado":
          labelCertidao = "Certidão de Casamento:";
          break;
        case "uniao_estavel":
          labelCertidao = "Certidão de Nascimento";
          //labelCertidao = 'Certidão de União Estável:';
          break;
        default:
          labelCertidao = "Certidão de Nascimento ou Casamento:";
      }

      return {
        cf_anexo_foto_cracha: "Foto:",
        // 'cf_anexo_carteira_trabalho_foto': 'Carteira de Trabalho (página de foto):',
        // 'cf_anexo_carteira_trabalho_qualificacao': 'Carteira de Trabalho (página de Qualificação):',
        cf_anexo_carteira_trabalho_digital: "CTPS Digital:",
        cf_anexo_rg: labelNomeRg,
        cf_anexo_cpf: "CPF/CNH:",
        cf_anexo_cnh: "CNH:",
        cf_anexo_titulo_eleitor: "Título de eleitor:",
        cf_anexo_pis_pasep: "PIS/PASEP:",
        cf_anexo_comprovante_residencia: "Comprovante de Residência:",
        cf_anexo_certidao_nascimento_casamento: labelCertidao,
        cf_anexo_comprovante_escolaridade: "Comprovante de Escolaridade:",
        cf_anexo_info_bancaria: "Informações bancárias:",
        cf_anexo_comprovante_desligamento: "Comprovante de desligamento:",
        cf_anexo_uniao_estavel: "Certidão de União Estável:",
        cf_anexo_carteira_vacinacao: "Carteira de Vacinação:",
      };
    },
  },
  created() {
    this.updateCache();
  },
  watch: {
    anexosCandidato: {
      handler() {
        this.updateCache();
      },
      deep: true,
    },
  },
  methods: {
    updateCache() {
      this.anexosCache = {};
      this.campos.forEach((campo) => {
        this.anexosCache[campo] = this.findAnexo(campo);
      });
      this.camposOpcionais.forEach((campo) => {
        this.anexosCache[campo] = this.findAnexo(campo);
      });
    },
    findAnexo(nomeCampo) {
      return (
        this.anexosCandidato.find(
          (anexo) => anexo.nome_campo_form === nomeCampo
        ) || {}
      );
    },
    // Um anexo é requerido se ainda não existir no banco de dados ou se 'resposta_sworks' conter um erro
    // isAnexoRequired(nomeCampo) {
    //   //return false;

    //   const anexo = this.anexosCache[nomeCampo];
    //   // existe anexo no banco de dados
    //   if (anexo) {
    //     // se resposta_sworks tem conteúdo, anexo está com erro
    //     if (anexo.resposta_sworks) {
    //       return true;
    //       // anexo não tem erro
    //     } else {
    //       return false;
    //     }
    //     // nao existe anexo no banco de dados, portanto tem que exibir o campo
    //   } else {
    //     return true;
    //   }

    // },

    isAnexoRequired(nomeCampo, camposRequeridos = null) {
      // Se camposRequeridos for fornecido, verifica se o campo está na lista
      if (camposRequeridos && !camposRequeridos.includes(nomeCampo)) {
        return false; // Se o campo não estiver na lista, ele não é obrigatório
      }


      // Lógica existente, que continua funcionando sem alterações
      const anexo = this.anexosCache[nomeCampo];

      if (anexo) {
        // Se resposta_sworks tem conteúdo, anexo está com erro
        if (anexo.resposta_sworks && anexo.status != 1) {
          return true;
        } else {
          return false;
        }
      } else {
        // Não existe anexo no banco de dados, portanto, o campo é obrigatório
        return true;
      }
    },
  },
};
</script>

<style>
.error-message {
  color: red;
  margin-top: 10px;
  border-bottom: 2px solid red;
}
</style>